import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type OrganisationListItem = ResultOf<
  typeof organisationListQueryGraphql
>["organisations"]["data"][number];
export const organisationListQueryGraphql = graphql(`
  query OrganisationList(
    $page: Int
    $first: Int!
    $search: String
    $is_verified: Boolean
    $sales_agent_ids: [ID!]
    $orderBy: [QueryOrganisationsOrderByOrderByClause!]
  ) {
    organisations(
      first: $first
      page: $page
      search: $search
      is_verified: $is_verified
      sales_agent_ids: $sales_agent_ids
      orderBy: $orderBy
    ) {
      data {
        ...OrganisationFields
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
